import {fork} from 'redux-saga/effects';
import {saga as authSaga} from 'api/auth';
import {saga as prefetchSaga} from 'api/prefetch';
import {saga as pushSaga} from 'api/push';

export default function* saga() {
  yield fork(authSaga);
  yield fork(prefetchSaga);
  yield fork(pushSaga);
}
